export const createCustomParams = (customParams: string): any => {
  let _customParams = customParams;
  return {
    updateOrAdd: (key: string, value: string): void => {
      if (_customParams.includes(`${key}=`)) {
        // already present, so replace the value
        const regexp = new RegExp(`${key}[^&]+`);
        _customParams = _customParams.replace(regexp, `${key}=${value}`);
      } else {
        // not present, so simply add
        _customParams = `${_customParams}&${key}=${value}`;
      }
    },
    get: (): string => {
      return _customParams;
    },
    getValuesForKey: (key: string): string => {
      if (_customParams.includes(`${key}=`)) {
        const regexp = new RegExp(`${key}[^&]+`);
        const keyAndValues = regexp.exec(_customParams)[0];
        const keyAndValuesArray = keyAndValues.split('=');
        return keyAndValuesArray[1];
      }
      return;
    },
  };
};
